import {
    OPEN_CLOSE_BET_HISTORY,
    SELECT_BET_HISTORY_GAME,
    SELECT_BET_HISTORY_TAB,
    TOGGLE_BET_HISTORY_FILTER_WINS
} from '../constants/actionTypes';
import {ACTIVE_BETS_TAB} from '../constants/identifiers';
import defaultStoreValues from '../../../constants/defaultStoreValues';
import {updateLocalBetsReadStatus} from '../helpers/betHistoryHelpers';

export default (state, action) => {
    switch (action.type) {
        case OPEN_CLOSE_BET_HISTORY:
            let newIsBetHistoryOpen = !state.isBetHistoryOpen;
            updateLocalBetsReadStatus(
                defaultStoreValues.selectedBetHistoryTab === ACTIVE_BETS_TAB,
                defaultStoreValues.selectedBetHistoryGame
            );
            return {
                ...state,
                isBetHistoryOpen: newIsBetHistoryOpen,
                selectedBetHistoryTab: defaultStoreValues.selectedBetHistoryTab,
                selectedBetHistoryGame: defaultStoreValues.selectedBetHistoryGame,
                filterWinsBetHistory: defaultStoreValues.filterWinsBetHistory
            };
        case SELECT_BET_HISTORY_TAB:
            updateLocalBetsReadStatus(action.tabIndex === ACTIVE_BETS_TAB, state.selectedBetHistoryGame);
            return {
                ...state,
                selectedBetHistoryTab: action.tabIndex
            };
        case SELECT_BET_HISTORY_GAME:
            updateLocalBetsReadStatus(state.selectedBetHistoryTab === ACTIVE_BETS_TAB, action.gameChannel);
            return {
                ...state,
                selectedBetHistoryGame: action.gameChannel
            };
        case TOGGLE_BET_HISTORY_FILTER_WINS:
            let newFilterWinsBetHistory = !state.filterWinsBetHistory;
            return {
                ...state,
                filterWinsBetHistory: newFilterWinsBetHistory
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/reducers/betHistoryReducer.js